module.exports = __webpack_public_path__ + "static/media/anniu2_hui.f58fb66c.png";